import React, {Component, useEffect} from 'react';
import {observer} from 'mobx-react';
import {
    saveData,
    cancelChanged,
    selectScrollField,
    isMovementsPanelShown
} from '../../Design/actions/Screen';
import {getLastLevelFields} from '../../Common/actions/Screen';
import {textConst, texts, getLocalizedText} from '../../../../constants/TextConst';
import {Button} from '../../../../components/Common/Buttons/Button';
import Search from '../../../../components/Common/Search';
import Movements from '../../../../components/Common/Movements';
import PersonalActionsMenu from './PersonalMenuActionsMenu';
import {DesignList} from '../../Design/components/Design';
import {sendMonitor} from '../../../../utils/monitoring';
import checkMark from '../../../../images/check_mark.png';

class MenuBottom extends Component<any, any> {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleCancel() {
        const {closePanel, screen} = this.props;
        cancelChanged(screen);
        closePanel();
    }

    handleSave() {
        const {closePanel, screensStore} = this.props;
        saveData(screensStore, closePanel);
    }

    render() {
        return (
            <div className="panel-bottom">
                <Button
                    componentClasses="cancel-btn"
                    onClick={this.handleCancel}
                    text={getLocalizedText(texts.cancel)}
                />
                <Button
                    componentClasses="confirm-btn"
                    onClick={this.handleSave}
                    img={checkMark}
                    alt={textConst.confirmAlt}
                    text={getLocalizedText(texts.save)}
                    labeled
                />
            </div>
        );
    }
}

@observer
class MenuContent extends Component<any, any> {
    constructor(props) {
        super(props);

        this.selectSearchOption = this.selectSearchOption.bind(this);
    }

    selectSearchOption(field) {
        selectScrollField(field);
    }

    renderMovementsPanel() {
        const {screen} = this.props;
        return (
            <div>
                <Search
                    options={getLastLevelFields(screen)}
                    placeholder={`${getLocalizedText(texts.search)} ${getLocalizedText(
                        texts.entity
                    )}`}
                    onOptionSelect={this.selectSearchOption}
                />
                {isMovementsPanelShown(screen) && <Movements field={screen.selected} />}
            </div>
        );
    }

    renderActionsMenu() {
        const {screen, open} = this.props;
        const {active, parentScreen} = screen;
        const actionsOpen =
            open &&
            active &&
            !active.isChanging &&
            (!parentScreen || parentScreen.active === screen.active);
        return <PersonalActionsMenu open={actionsOpen} field={active} />;
    }

    renderList() {
        const {screen} = this.props;
        const movementsPanelShown = isMovementsPanelShown(screen);
        return (
            <div className={`list ${!movementsPanelShown && 'longer'}`}>
                <div className="line" />
                <DesignList screen={screen} />
                {this.renderActionsMenu()}
            </div>
        );
    }

    render() {
        return (
            <div className="content">
                {this.renderMovementsPanel()}
                {this.renderList()}
            </div>
        );
    }
}

const PersonalMenu = observer(props => {
    const {screen, open, closePanel, screensStore} = props;
    useEffect(() => {
        sendMonitor('mainMenu - open personal menu design');
    }, []);

    return (
        <div className="screen">
            <div className={`content-wrapper`}>
                <MenuContent screen={screen} open={open} />
            </div>
            <MenuBottom screen={screen} closePanel={closePanel} screensStore={screensStore} />
        </div>
    );
});

export default PersonalMenu;
